const structure = "https://vmcmu.vet.cmu.ac.th/assets/images/logo/Slide4.png";


export {
    structure
}